import React from 'react';

interface DialogProviderContextType {
    showModal: (
        modalKey: string,
        component: React.ComponentType,
        modalProps?: Record<string, unknown>,
        onClose?: () => void
    ) => void;
    hideModal: (modalKey: string, onClose?: () => void) => void;
    removeModal: (modalKey: string) => void;
}
export const DialogProviderContext = React.createContext<DialogProviderContextType | null>(null);
